import React, { useMemo, useState, useEffect } from "react";
import { FaTrash, FaShoppingCart, FaPlus, FaMinus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider";
const CATEGORIES = [
    { key: "starters", label: "Starters" },
    { key: "mains", label: "Mains" },
    { key: "main", label: "Main" },
    { key: "desserts", label: "Desserts" },
    { key: "softdrinks", label: "Soft Drinks" },
    { key: "beverages", label: "Beverages" },
];

const CUISINES = ["Indian", "Chinese", "South Indian", "Continental", "Beverage", "Hot", "Cold"];
const EVENTS = ["WEDDING", "BIRTHDAY", "ENGAGEMENT", "ANNIVERSARY", "OTHER"];

// Add-Ons configuration (matching Flutter code)
const ADD_ONS = {
    'SERVICE_BOYS': {
        label: 'Service Boys',
        icon: '👥',
    },
    'PAPER_PLATES': {
        label: 'Paper Plates',
        icon: '🍽️',
    },
    'WATER_BOTTLES': {
        label: 'Water Bottles',
        icon: '💧',
    },
    'DISPOSABLE_CUPS': {
        label: 'Disposable Cups',
        icon: '🥤',
    },
    'TISSUE_PAPER': {
        label: 'Tissue Paper',
        icon: '🧻',
    },
};

const CustomizeMenu = () => {
    const [step, setStep] = useState(1);
    const [data, setData] = useState([]);
    const [specialRequests, setSpecialRequests] = useState("");
    const [loading, setLoading] = useState(false);

    const [customerAddress, setCustomerAddress] = useState(null);

    // Form state - matching Flutter code exactly
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        eventType: "",
        date: "",
        time: "",
        fullAddress: "",        // Change from "location" to "fullAddress"
        city: "",
        state: "",
        country: "",
        pincode: "",            // Add this
        vegPlates: "",
        nonVegPlates: "",
        mixedPlates: "",
        people: "",
        budget: "",
        gstRequirement: "",
    });

    // Address state
    // const [selectedAddress, setSelectedAddress] = useState(null);
    // const [selectedAddressId, setSelectedAddressId] = useState(null);
    // const [savedAddresses, setSavedAddresses] = useState([]);
    // const [showAddressModal, setShowAddressModal] = useState(false);

    // Add-Ons state - matching Flutter code
    const [addOns, setAddOns] = useState({
        'SERVICE_BOYS': { selected: false, quantity: 0 },
        'PAPER_PLATES': { selected: false, quantity: 0 },
        'WATER_BOTTLES': { selected: false, quantity: 0 },
        'DISPOSABLE_CUPS': { selected: false, quantity: 0 },
        'TISSUE_PAPER': { selected: false, quantity: 0 },
    });

    // Menu selection state
    const [isVeg, setIsVeg] = useState(true);
    const [eventTypes, setEventTypes] = useState([]);
    const [cuisineTypes, setCuisineTypes] = useState([]);
    const [mealType, setMealType] = useState("mixed");
    const [activeCategories, setActiveCategories] = useState([
        "starters", "mains", "main", "desserts", "softdrinks", "beverages"
    ]);
    const [budgetKey, setBudgetKey] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [search, setSearch] = useState("");
    const [cart, setCart] = useState({});
    const [expandedCategory, setExpandedCategory] = useState(null);

    // Category items for menu (matching Flutter's categoryItems map)
    const [categoryItems, setCategoryItems] = useState({});
    const [customizedCategories, setCustomizedCategories] = useState([]);

    const customerId = localStorage.getItem("customerId");
    const token = localStorage.getItem("authToken");
    const navigate = useNavigate();

    // Check if user is logged in
    useEffect(() => {
        if (!token || !customerId) {
            alert("Please login to customize menu");
            navigate("/");
        }
    }, [token, customerId, navigate]);

    // Load saved form data from localStorage on mount
    useEffect(() => {
        const savedEnquiry = localStorage.getItem('cateringEnquiry');
        if (savedEnquiry) {
            const parsed = JSON.parse(savedEnquiry);
            setFormData(parsed.formData || {});
            setSpecialRequests(parsed.specialRequests || "");
            setAddOns(parsed.addOns || addOns);
            // setSelectedAddressId(parsed.selectedAddressId || null);
            // setSelectedAddress(parsed.selectedAddress || null);

            if (parsed.cart && Object.keys(parsed.cart).length > 0) {
                setCart(parsed.cart);
                setStep(2);
            }
        }
    }, []);

    // Save to localStorage
    useEffect(() => {
        const enquiryData = {
            formData,
            specialRequests,
            cart,
            addOns,

        };
        localStorage.setItem('cateringEnquiry', JSON.stringify(enquiryData));
    }, [formData, specialRequests, cart, addOns,]);

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle Confirm & Select button
    const handleConfirmAndSelect = () => {
        // Validate form
        if (!formData.name || !formData.email || !formData.phone) {
            alert("❌ Please fill in your personal details.");
            return;
        }

        if (!formData.eventType || !formData.date || !formData.time) {
            alert("❌ Please fill in event details.");
            return;
        }

        // Update this validation


        setStep(2);
    };

    // Handle back to form
    const handleBackToForm = () => {
        setStep(1);
    };

    // Build selected add-ons for API
    const buildSelectedAddOns = () => {
        return Object.entries(addOns)
            .filter(([_, value]) => value.selected)
            .map(([key, value]) => ({
                addOnType: key,
                quantity: value.quantity,
                selected: true,
            }));
    };

    // Submit final enquiry
    // Helper function to convert date format from YYYY-MM-DD to DD-MM-YYYY
    const formatDateForAPI = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };


    useEffect(() => {
        fetchCustomerAddress();
    }, []);

    const fetchCustomerAddress = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const customerId = localStorage.getItem("customerId");

            const response = await axios.get(
                `https://backend.maamaas.com/subscription/api/customer/get/address?customerId=${customerId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            let addressData = null;

            if (Array.isArray(response.data) && response.data.length > 0) {
                addressData = response.data[0];
            } else {
                addressData = response.data;
            }

            console.log("📍 Stored Address:", addressData);

            setCustomerAddress(addressData);

        } catch (error) {
            console.error("Address fetch error:", error);
            setCustomerAddress(null);
        }
    };



    // Submit final enquiry
    const handleSubmitEnquiry = async () => {
        try {

            if (!cart || Object.keys(cart).length === 0) {
                alert("❌ Please select at least one item.");
                return;
            }

            if (!formData.eventType) {
                alert("❌ Please select an event type.");
                return;
            }

            if (!customerAddress?.address) {
                alert("❌ Please add your address before submitting enquiry.");
                return;
            }

            const dishIds = Object.values(cart).map(c =>
                Number(c.item.id.replace("it", ""))
            );

            const itemNames = Object.values(cart).map(c => c.item.name);

            const vegPlates = parseInt(formData.vegPlates) || 0;
            const nonVegPlates = parseInt(formData.nonVegPlates) || 0;
            const mixedPlates = parseInt(formData.mixedPlates) || 0;
            const budget = parseFloat(formData.budget) || 0;

            const formattedDate = formatDateForAPI(formData.date);

            // ✅ Convert AddOns
            const selectedAddOns = Object.entries(addOns)
                .filter(([key, value]) => value.selected === true)
                .map(([key, value]) => ({
                    addOnType: key,
                    quantity: value.quantity,
                    selected: true
                }));

            console.log("🧾 Selected AddOns:", selectedAddOns);

            const payload = {
                fullName: formData.name,
                email: formData.email,
                phoneNumber: formData.phone,
                event: "EVENT",
                eventType: formData.eventType,
                eventDate: formattedDate,
                eventTime: formData.time,

                fullAddress: customerAddress.address,
                city: customerAddress.city,
                state: customerAddress.state,
                pincode: customerAddress.pincode,
                latitude: customerAddress.latitude,
                longitude: customerAddress.longitude,
                country: "India",

                budget,
                vegPlates,
                nonVegPlates,
                mixedPlates,
                additionalRequests: specialRequests,
                dishId: dishIds,
                items: itemNames,

                // 🔥 AddOns sent here
                addOns: selectedAddOns
            };

            console.log("🚀 Final Payload:");
            console.log(JSON.stringify(payload, null, 2));

            const response = await axios.post(
                `testing.maamaas./catering/api/user/enquiry/create/?customerId=${localStorage.getItem("customerId")}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                alert("✅ Menu Enquiry Submitted Successfully!");
                // navigate("/enquiry-success");
            }

        } catch (error) {
            console.error("Enquiry submission error:", error);
            alert("❌ Failed to submit enquiry.");
        }
    };






    // Fetch dishes and organize by category (matching Flutter's loadCategories)
    // Fetch dishes
    useEffect(() => {
        const fetchDishes = async () => {
            if (!token) {
                console.log("No token found");
                return;
            }

            console.log("Fetching dishes for step:", step);
            setLoading(true);

            try {
                const response = await axios.get(
                    "testing.maamaas./catering/api/dishes/getAll",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log("API Response:", response.data);

                if (response.data && Array.isArray(response.data)) {
                    const dishes = response.data;
                    console.log("Total dishes received:", dishes.length);

                    // Log all parent categories
                    const parentCategories = dishes.filter(d => d.parentId === 0);
                    console.log("Parent categories found:", parentCategories.map(c => ({ name: c.dishName, id: c.dishId })));

                    const categoryMap = {};
                    const catList = [];

                    for (const category of parentCategories) {
                        const items = dishes.filter(d => d.parentId === category.dishId);
                        console.log(`Category "${category.dishName}" has ${items.length} items:`, items.map(i => i.dishName));

                        const formattedItems = items.map(item => ({
                            dishId: item.dishId,
                            dishName: item.dishName,
                            dishType: item.dishType,
                            price: item.effectivePrice || item.dishPrice || 0,
                            isVeg: item.dishType?.toLowerCase() === "veg",
                        }));

                        catList.push(category.dishName);
                        categoryMap[category.dishName] = formattedItems;
                    }

                    console.log("Final categoryMap:", categoryMap);
                    console.log("Final categories list:", catList);

                    setCategoryItems(categoryMap);
                    setCustomizedCategories(catList);
                } else {
                    console.log("Response data is not an array:", response.data);
                }
            } catch (error) {
                console.error("API Error Details:", error);
                if (error.response) {
                    console.log("Error response:", error.response.status, error.response.data);
                }
            } finally {
                setLoading(false);
            }
        };

        if (step === 2) {
            console.log("Step 2 reached, fetching dishes...");
            fetchDishes();
        }
    }, [token, step]);

    // Filter helpers
    const toggleEvent = (e) =>
        setEventTypes((prev) => (prev.includes(e) ? prev.filter((x) => x !== e) : [...prev, e]));

    const toggleCuisine = (c) =>
        setCuisineTypes((prev) => (prev.includes(c) ? prev.filter((x) => x !== c) : [...prev, c]));

    const toggleCategory = (key) =>
        setActiveCategories((prev) =>
            prev.includes(key) ? prev.filter((x) => x !== key) : [...prev, key]
        );

    const visibleItems = useMemo(() => {
        return data.filter((it) => {
            if (selectedCategory && it.category.toLowerCase() !== selectedCategory.toLowerCase()) {
                return false;
            }
            if (!activeCategories.includes(it.category)) return false;
            if (cuisineTypes.length && !cuisineTypes.includes(it.cuisine)) return false;
            if (mealType === "veg" && !it.isVeg) return false;
            if (mealType === "nonveg" && it.isVeg) return false;

            if (search.trim()) {
                const s = search.toLowerCase();
                if (!(`${it.name} ${it.cuisine} ${it.category}`.toLowerCase().includes(s)))
                    return false;
            }

            return true;
        });
    }, [data, activeCategories, cuisineTypes, mealType, search, selectedCategory]);

    const isSelected = (id) => !!cart[id];

    const toggleItem = (item) => {
        setCart((prev) => {
            const next = { ...prev };
            if (next[item.id]) {
                delete next[item.id];
            } else {
                next[item.id] = { item, qty: 1 };
            }
            return next;
        });
    };

    const incQty = (id) =>
        setCart((prev) => ({ ...prev, [id]: { ...prev[id], qty: prev[id].qty + 1 } }));

    const decQty = (id) =>
        setCart((prev) => {
            const q = prev[id].qty - 1;
            const next = { ...prev };
            if (q <= 0) delete next[id];
            else next[id] = { ...prev[id], qty: q };
            return next;
        });

    const selectAllVisible = () => {
        setCart((prev) => {
            const next = { ...prev };
            visibleItems.forEach((it) => {
                if (!next[it.id]) next[it.id] = { item: it, qty: 1 };
            });
            return next;
        });
    };

    const clearAll = () => setCart({});

    const handleRemove = (id) => {
        const updatedCart = { ...cart };
        delete updatedCart[id];
        setCart(updatedCart);
    };

    const totalItems = useMemo(
        () => Object.values(cart).reduce((s, r) => s + r.qty, 0),
        [cart]
    );

    const totalAmount = useMemo(
        () => Object.values(cart).reduce((s, r) => s + r.qty * r.item.price, 0),
        [cart]
    );

    // Fetch addresses (matching Flutter's fetchAddresses)
    const fetchAddresses = async () => {
        try {
            const response = await axios.get(
                "https://backend.maamaas.com/food/api/address/get",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data && Array.isArray(response.data)) {
                // setSavedAddresses(response.data);
            }
        } catch (error) {
            console.error("Error fetching addresses:", error);
        }
    };



    return (
        <div style={styles.page}>
            <style>{`
                .no-scrollbar { scrollbar-width: none; }
                .no-scrollbar::-webkit-scrollbar { display: none; }
                .veg-icon { color: #22c55e; }
                .nonveg-icon { color: #ef4444; }
                .tag { font-size: 12px; padding: 2px 6px; border-radius: 999px; }
                .tag-veg { background:#e8f7ec; color:#1f7a3a; border:1px solid #bfe8cb; }
                .tag-nonveg { background:#ffecec; color:#b00020; border:1px solid #ffc5c5; }
                .btn { padding:8px 12px; border:none; border-radius:6px; cursor:pointer; font-weight:600; font-size:14px; }
                .btn-primary { background:#ee6521; color:#fff; }
                .btn-secondary { background:#6c757d; color:#fff; }
                .btn-success { background:#28a745; color:#fff; }
            `}</style>



            <div className="container-fluid" style={styles.container}>
                <div className="row">
                    <div className="col-lg-2">

                    </div>
                    <div className="col-lg-10">


                        {/* Content Area */}
                        <div style={styles.contentArea}>
                            {step === 1 ? (
                                /* STEP 1: EVENT DETAILS FORM */
                                <div style={styles.formSection}>
                                    <h3 style={styles.formTitle}> Event Details</h3>

                                    <div style={styles.formGrid}>
                                        {/* Event Type - Dropdown */}
                                        <div style={styles.formFieldFull}>
                                            <label style={styles.formLabel}>Event Type *</label>
                                            <select
                                                name="eventType"
                                                value={formData.eventType}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                            >
                                                <option value="">Select Event Type</option>
                                                {EVENTS.map(event => (
                                                    <option key={event} value={event}>{event}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Date and Time Row */}
                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Date *</label>
                                            <input
                                                type="date"
                                                name="date"
                                                value={formData.date}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                min={new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]}
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Time *</label>
                                            <input
                                                type="time"
                                                name="time"
                                                value={formData.time}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                            />
                                        </div>

                                        {/* Personal Details */}
                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Full Name *</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="Enter your full name"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Email *</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="your@email.com"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Phone *</label>
                                            <input
                                                type="tel"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="10-digit mobile number"
                                            />
                                        </div>

                                        {/* Delivery Address - Clickable Card */}
                                        {/* <div style={styles.formFieldFull}>
                                            <label style={styles.formLabel}>Full Address *</label>
                                            <input
                                                type="text"
                                                name="fullAddress"
                                                value={formData.fullAddress}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="House No, Building, Street, Landmark"
                                                required
                                            />
                                        </div>

                                      
                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Country</label>
                                            <input
                                                type="text"
                                                name="country"
                                                value={formData.country}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="Country"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>State</label>
                                            <input
                                                type="text"
                                                name="state"
                                                value={formData.state}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="State"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>City</label>
                                            <input
                                                type="text"
                                                name="city"
                                                value={formData.city}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="City"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Pincode</label>
                                            <input
                                                type="text"
                                                name="pincode"
                                                value={formData.pincode}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="Pincode"
                                            />
                                        </div> */}

                                        {/* People and Budget Row */}
                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>No. of People</label>
                                            <input
                                                type="number"
                                                name="people"
                                                value={formData.people}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="Number of guests"
                                                min="1"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={styles.formLabel}>Estimated Budget (₹)</label>
                                            <input
                                                type="number"
                                                name="budget"
                                                value={formData.budget}
                                                onChange={handleInputChange}
                                                style={styles.formInput}
                                                placeholder="Budget amount"
                                                min="0"
                                            />
                                        </div>

                                        {/* Plate Counts - Three columns */}
                                        <div style={styles.formField}>
                                            <label style={{ ...styles.formLabel, color: '#22c55e' }}>Veg Plates</label>
                                            <input
                                                type="number"
                                                name="vegPlates"
                                                value={formData.vegPlates}
                                                onChange={handleInputChange}
                                                style={{ ...styles.formInput, borderColor: '#22c55e' }}
                                                placeholder="Veg"
                                                min="0"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={{ ...styles.formLabel, color: '#ef4444' }}>Non-Veg Plates</label>
                                            <input
                                                type="number"
                                                name="nonVegPlates"
                                                value={formData.nonVegPlates}
                                                onChange={handleInputChange}
                                                style={{ ...styles.formInput, borderColor: '#ef4444' }}
                                                placeholder="Non-Veg"
                                                min="0"
                                            />
                                        </div>

                                        <div style={styles.formField}>
                                            <label style={{ ...styles.formLabel, color: '#f97316' }}>Mixed Plates</label>
                                            <input
                                                type="number"
                                                name="mixedPlates"
                                                value={formData.mixedPlates}
                                                onChange={handleInputChange}
                                                style={{ ...styles.formInput, borderColor: '#f97316' }}
                                                placeholder="Mixed"
                                                min="0"
                                            />
                                        </div>

                                        {/* GST Requirement */}
                                        {/* <div style={styles.formFieldFull}>
                                    <label style={styles.formLabel}>GST Requirement</label>
                                    <input
                                        type="text"
                                        name="gstRequirement"
                                        value={formData.gstRequirement}
                                        onChange={handleInputChange}
                                        style={styles.formInput}
                                        placeholder="GST number if applicable"
                                    />
                                </div> */}
                                    </div>

                                    {/* Confirm Button */}
                                    <div style={styles.buttonContainer}>
                                        <button style={styles.confirmBtn} onClick={handleConfirmAndSelect}>
                                            Next →
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                /* STEP 2: MENU SELECTION - NEW LAYOUT */
                                <div style={styles.menuContainer}>
                                    {/* Back Button - Full width above columns */}
                                    <div>
                                        <button style={styles.backButton} onClick={handleBackToForm}>
                                            ← Back to Event Details
                                        </button>
                                    </div>

                                    {/* Two Column Layout */}
                                    <div style={styles.twoColumnLayout}>
                                        {/* LEFT COLUMN (7) - Menu Items & Add-Ons (Scrollable) */}
                                        <div style={styles.leftColumn}>
                                            {/* Veg/Non-Veg Toggle */}
                                            <div style={styles.toggleContainer}>
                                                <h3 style={styles.sectionTitle}>Select your Menu</h3>
                                                <div style={styles.toggleWrapper}>
                                                    <button
                                                        style={{
                                                            ...styles.toggleButton,
                                                            ...(isVeg ? styles.toggleButtonActive : {}),
                                                            backgroundColor: isVeg ? '#22c55e' : '#fff',
                                                            color: isVeg ? '#fff' : '#666',
                                                            borderColor: '#22c55e'
                                                        }}
                                                        onClick={() => setIsVeg(true)}
                                                    >
                                                        Veg
                                                    </button>
                                                    <button
                                                        style={{
                                                            ...styles.toggleButton,
                                                            ...(!isVeg ? styles.toggleButtonActive : {}),
                                                            backgroundColor: !isVeg ? '#ef4444' : '#fff',
                                                            color: !isVeg ? '#fff' : '#666',
                                                            borderColor: '#ef4444'
                                                        }}
                                                        onClick={() => setIsVeg(false)}
                                                    >
                                                        Non-Veg
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Category Items - Scrollable */}
                                            <div style={styles.categoriesContainer}>
                                                {customizedCategories.length === 0 ? (
                                                    <div style={styles.loadingContainer}>
                                                        <div style={styles.spinner}></div>
                                                        <p style={styles.loadingText}>Loading menu...</p>
                                                    </div>
                                                ) : (
                                                    customizedCategories.map((category) => {
                                                        const items = categoryItems[category]?.filter(item => {
                                                            if (isVeg) {
                                                                return item.dishType?.toLowerCase() === "veg";
                                                            } else {
                                                                return item.dishType?.toLowerCase() === "non_veg";
                                                            }
                                                        }) || [];

                                                        return (
                                                            <div key={category} style={styles.categoryCard}>
                                                                <div
                                                                    style={styles.categoryHeader}
                                                                    onClick={() => setExpandedCategory(
                                                                        expandedCategory === category ? null : category
                                                                    )}
                                                                >
                                                                    <div style={styles.categoryTitleWrapper}>
                                                                        <div style={styles.categoryIcon}>
                                                                            {category[0]}
                                                                        </div>
                                                                        <div>
                                                                            <h4 style={styles.categoryTitle}>{category}</h4>
                                                                            <p style={styles.categorySubtitle}>
                                                                                {items.length} items available
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <span style={styles.categoryArrow}>
                                                                        {expandedCategory === category ? '▼' : '▶'}
                                                                    </span>
                                                                </div>

                                                                {expandedCategory === category && (
                                                                    <div style={styles.categoryItems}>
                                                                        {items.length === 0 ? (
                                                                            <p style={styles.noItemsText}>
                                                                                {isVeg
                                                                                    ? "No vegetarian items in this category"
                                                                                    : "No non-vegetarian items in this category"
                                                                                }
                                                                            </p>
                                                                        ) : (
                                                                            items.map((item) => {
                                                                                const itemId = `it${item.dishId}`;
                                                                                const isSelected = !!cart[itemId];
                                                                                return (
                                                                                    <div
                                                                                        key={item.dishId}
                                                                                        style={{
                                                                                            ...styles.menuItem,
                                                                                            ...(isSelected ? styles.menuItemSelected : {})
                                                                                        }}
                                                                                    >
                                                                                        <div style={styles.menuItemLeft}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={isSelected}
                                                                                                onChange={() => {
                                                                                                    const formattedItem = {
                                                                                                        id: itemId,
                                                                                                        name: item.dishName,
                                                                                                        price: item.price,
                                                                                                        isVeg: item.isVeg,
                                                                                                    };
                                                                                                    toggleItem(formattedItem);
                                                                                                }}
                                                                                                style={styles.menuCheckbox}
                                                                                            />
                                                                                            <span style={{
                                                                                                ...styles.vegNonVegDot,
                                                                                                backgroundColor: item.isVeg ? '#22c55e' : '#ef4444'
                                                                                            }} />
                                                                                            <span style={styles.menuItemName}>
                                                                                                {item.dishName}
                                                                                            </span>
                                                                                        </div>
                                                                                        <span style={styles.menuItemPrice}>
                                                                                            ₹{item.price}
                                                                                        </span>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    })
                                                )}
                                            </div>

                                            {/* Add-Ons Section */}
                                            <div style={styles.addOnsSection}>
                                                <h3 style={styles.sectionTitle}>Add-Ons</h3>
                                                <p style={styles.addOnsSubtitle}>Select additional services and items</p>

                                                {Object.entries(ADD_ONS).map(([key, config]) => {
                                                    const addOn = addOns[key];
                                                    return (
                                                        <div key={key} style={styles.addOnCard}>
                                                            <div style={styles.addOnHeader}>
                                                                <div style={styles.addOnIcon}>
                                                                    {config.icon}
                                                                </div>
                                                                <span style={styles.addOnLabel}>{config.label}</span>
                                                                <label className="switch">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={addOn.selected}
                                                                        onChange={(e) => {
                                                                            setAddOns({
                                                                                ...addOns,
                                                                                [key]: {
                                                                                    selected: e.target.checked,
                                                                                    quantity: e.target.checked ? 1 : 0
                                                                                }
                                                                            });
                                                                        }}
                                                                    />
                                                                    <span className="slider"></span>
                                                                </label>
                                                            </div>

                                                            {addOn.selected && (
                                                                <div style={styles.quantitySelector}>
                                                                    <span style={styles.quantityLabel}>Quantity:</span>
                                                                    <div style={styles.quantityControls}>
                                                                        <button
                                                                            style={styles.quantityBtn}
                                                                            onClick={() => {
                                                                                if (addOn.quantity > 0) {
                                                                                    setAddOns({
                                                                                        ...addOns,
                                                                                        [key]: {
                                                                                            ...addOn,
                                                                                            quantity: addOn.quantity - 1
                                                                                        }
                                                                                    });
                                                                                }
                                                                            }}
                                                                        >
                                                                            <FaMinus size={12} />
                                                                        </button>
                                                                        <span style={styles.quantityValue}>
                                                                            {addOn.quantity}
                                                                        </span>
                                                                        <button
                                                                            style={styles.quantityBtn}
                                                                            onClick={() => {
                                                                                setAddOns({
                                                                                    ...addOns,
                                                                                    [key]: {
                                                                                        ...addOn,
                                                                                        quantity: addOn.quantity + 1
                                                                                    }
                                                                                });
                                                                            }}
                                                                        >
                                                                            <FaPlus size={12} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* Special Requests */}
                                            <div style={styles.specialRequestsSection}>
                                                <h3 style={styles.sectionTitle}>Special Requests</h3>
                                                <textarea
                                                    style={styles.specialRequestsInput}
                                                    placeholder="Any special requirements or requests..."
                                                    value={specialRequests}
                                                    onChange={(e) => setSpecialRequests(e.target.value)}
                                                    rows={4}
                                                />
                                            </div>
                                        </div>

                                        {/* RIGHT COLUMN (5) - Selected Items Cart (Fixed) */}
                                        <div style={styles.rightColumn}>
                                            <div style={styles.cartSticky}>
                                                <div style={styles.selectedHeader}>
                                                    <h3 style={styles.cartTitle}>Selected Items</h3>
                                                    <div style={styles.cartIcon}>
                                                        <FaShoppingCart color="#28a745" size={24} />
                                                        {totalItems > 0 && (
                                                            <span style={styles.cartBadge}>{totalItems}</span>
                                                        )}
                                                    </div>
                                                </div>

                                                {Object.values(cart).length === 0 ? (
                                                    <div style={styles.emptyCart}>
                                                        <p style={styles.emptyCartText}>No items selected yet</p>
                                                        <p style={styles.emptyCartSubtext}>Select dishes from the left to add them here</p>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div style={styles.selectedList}>
                                                            {Object.values(cart).map(({ item, qty }) => (
                                                                <div key={item.id} style={styles.selectedItem}>
                                                                    <div style={styles.selectedItemInfo}>
                                                                        <div style={styles.selectedItemName}>{item.name}</div>

                                                                    </div>
                                                                    <div style={styles.selectedItemActions}>
                                                                        <button
                                                                            style={styles.qtyMiniBtn}
                                                                            onClick={() => decQty(item.id)}
                                                                        >
                                                                            <FaMinus size={10} />
                                                                        </button>
                                                                        <span style={styles.qtyMiniValue}>{qty}</span>
                                                                        <button
                                                                            style={styles.qtyMiniBtn}
                                                                            onClick={() => incQty(item.id)}
                                                                        >
                                                                            <FaPlus size={10} />
                                                                        </button>
                                                                        <button
                                                                            style={styles.removeBtn}
                                                                            onClick={() => handleRemove(item.id)}
                                                                        >
                                                                            <FaTrash size={12} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>


                                                        <button
                                                            style={styles.submitBtn}
                                                            onClick={() => {
                                                                if (window.confirm('Submit enquiry?')) {
                                                                    handleSubmitEnquiry();
                                                                }
                                                            }}
                                                        >
                                                            Submit Enquiry
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>


            </div>

        </div>
    );
};

/* ------------------ STYLES ------------------ */
const styles = {
    page: {
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        height: "100%",
        width: "100%",
        // backgroundColor: "#fafafa",
    },
    container: {
        // display: "flex",
        gap: 24,
        // maxWidth: "1400px",
        margin: "0 auto",
        padding: "20px 40px",
        height: "100%",
    },
    stepsSidebar: {
        width: "100px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "40px",
    },
    stepItem: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
    },
    stepCircle: {
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        backgroundColor: "#ddd",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
    },
    stepActive: {
        backgroundColor: "#ee6521",
    },
    stepCompleted: {
        backgroundColor: "#28a745",
    },
    stepLine: {
        width: "3px",
        height: "40px",
        backgroundColor: "#ddd",
        margin: "10px 0",
        transition: "all 0.3s ease",
    },
    stepLineActive: {
        backgroundColor: "#ee6521",
    },
    stepLabel: {
        marginTop: "8px",
        fontSize: "12px",
        fontWeight: "600",
        color: "#555",
        textAlign: "center",
    },
    stepLabelActive: {
        color: "#ee6521",
    },
    contentArea: {
        flex: 1,
        minWidth: 0,
        overflowY: "auto",
        paddingRight: "5px",
    },
    formSection: {
        backgroundColor: "#fff",
        borderRadius: "16px",
        padding: "0px",
        // boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        // maxWidth: "900px",
        margin: "0 auto",
    },
    formTitle: {
        fontSize: "24px",
        fontWeight: "600",
        // marginBottom: "24px",
        color: "#ee6521",
        textAlign: "center",
    },
    formGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "10px",
    },
    formField: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
    },
    formFieldFull: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        // gridColumn: "span 2",
    },
    formLabel: {
        fontSize: "14px",
        fontWeight: "500",
        color: "#555",
        marginLeft: "4px",
    },
    formInput: {
        padding: "12px",
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        fontSize: "14px",
        transition: "all 0.3s ease",
        outline: "none",
        backgroundColor: "#fafafa",
        "&:focus": {
            borderColor: "#ee6521",
            boxShadow: "0 0 0 2px rgba(177,93,198,0.1)",
        },
    },
    addressCard: {
        display: "flex",
        alignItems: "center",
        padding: "16px",
        backgroundColor: "#fafafa",
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            borderColor: "#ee6521",
            backgroundColor: "#f5f0ff",
        },
    },
    addressIcon: {
        fontSize: "20px",
        marginRight: "12px",
    },
    addressText: {
        flex: 1,
        fontSize: "14px",
        color: "#333",
    },
    addressChevron: {
        fontSize: "20px",
        color: "#ee6521",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "center",
        marginTop: "20px",
    },
    confirmBtn: {
        padding: "14px 40px",
        fontSize: "16px",
        fontWeight: "600",
        backgroundColor: "#ee6521",
        color: "#fff",
        border: "none",
        borderRadius: "30px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#9a4cb0",
            transform: "translateY(-2px)",
            boxShadow: "0 4px 12px rgba(177,93,198,0.3)",
        },
    },
    menuContainer: {
        width: "100%",
    },
    backButton: {
        padding: "10px 20px",
        backgroundColor: "#6c757d",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "600",
        marginBottom: "0px",
        "&:hover": {
            backgroundColor: "#5a6268",
        },
    },
    toggleContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "0px",
    },
    sectionTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#ee6521",
    },
    toggleWrapper: {
        display: "flex",
        gap: "10px",
    },
    toggleButton: {
        padding: "8px 20px",
        border: "2px solid",
        borderRadius: "20px",
        fontSize: "14px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.3s ease",
    },
    toggleButtonActive: {
        color: "#fff",
    },
    categoriesContainer: {
        marginBottom: "24px",
    },
    loadingContainer: {
        padding: "40px",
        textAlign: "center",
    },
    spinner: {
        width: "40px",
        height: "40px",
        border: "3px solid #f3f3f3",
        borderTop: "3px solid #ee6521",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        margin: "0 auto 16px",
    },
    loadingText: {
        color: "#999",
        fontSize: "14px",
    },
    categoryCard: {
        marginBottom: "16px",
        backgroundColor: "#fff",
        borderRadius: "12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        overflow: "hidden",
    },
    categoryHeader: {
        padding: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        backgroundColor: "#fff",
        "&:hover": {
            backgroundColor: "#fafafa",
        },
    },
    categoryTitleWrapper: {
        display: "flex",
        gap: "12px",
        alignItems: "center",
    },
    categoryIcon: {
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        backgroundColor: "#f0e6ff",
        color: "#ee6521",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: "18px",
    },
    categoryTitle: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#333",
        margin: "0 0 4px",
    },
    categorySubtitle: {
        fontSize: "12px",
        color: "#999",
        margin: 0,
    },
    categoryArrow: {
        fontSize: "16px",
        color: "#ee6521",
    },
    categoryItems: {
        padding: "16px",
        borderTop: "1px solid #f0f0f0",
        backgroundColor: "#fafafa",
    },
    noItemsText: {
        textAlign: "center",
        color: "#999",
        fontSize: "14px",
        fontStyle: "italic",
        padding: "20px",
    },
    menuItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px",
        marginBottom: "8px",
        backgroundColor: "#fff",
        border: "1px solid #f0f0f0",
        borderRadius: "8px",
        transition: "all 0.3s ease",
    },
    menuItemSelected: {
        backgroundColor: "#f5f0ff",
        borderColor: "#ee6521",
    },
    menuItemLeft: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
    },
    menuCheckbox: {
        width: "18px",
        height: "18px",
        cursor: "pointer",
        accentColor: "#ee6521",
    },
    vegNonVegDot: {
        width: "12px",
        height: "12px",
        borderRadius: "4px",
    },
    menuItemName: {
        fontSize: "14px",
        fontWeight: "500",
        color: "#333",
    },
    menuItemPrice: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#ee6521",
    },
    addOnsSection: {
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "24px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    },
    addOnsSubtitle: {
        fontSize: "12px",
        color: "#999",
        marginBottom: "16px",
    },
    addOnCard: {
        marginBottom: "12px",
        backgroundColor: "#fafafa",
        borderRadius: "8px",
        border: "1px solid #f0f0f0",
        overflow: "hidden",
    },
    addOnHeader: {
        padding: "16px",
        display: "flex",
        alignItems: "center",
        gap: "12px",
    },
    addOnIcon: {
        width: "32px",
        height: "32px",
        backgroundColor: "#f0e6ff",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "16px",
    },
    addOnLabel: {
        flex: 1,
        fontSize: "14px",
        fontWeight: "500",
        color: "#333",
    },
    switch: {
        position: "relative",
        display: "inline-block",
        width: "44px",
        height: "22px",
    },
    slider: {
        position: "absolute",
        cursor: "pointer",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#ccc",
        transition: ".3s",
        borderRadius: "22px",
        "&:before": {
            position: "absolute",
            content: '""',
            height: "18px",
            width: "18px",
            left: "2px",
            bottom: "2px",
            backgroundColor: "white",
            transition: ".3s",
            borderRadius: "50%",
        },
    },
    quantitySelector: {
        padding: "0 16px 16px 60px",
        display: "flex",
        alignItems: "center",
        gap: "16px",
    },
    quantityLabel: {
        fontSize: "14px",
        color: "#666",
    },
    quantityControls: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        backgroundColor: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        padding: "4px",
    },
    quantityBtn: {
        width: "28px",
        height: "28px",
        borderRadius: "4px",
        border: "none",
        backgroundColor: "#ee6521",
        color: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            backgroundColor: "#9a4cb0",
        },
    },
    quantityValue: {
        minWidth: "30px",
        textAlign: "center",
        fontSize: "14px",
        fontWeight: "600",
    },
    specialRequestsSection: {
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "20px",
        marginBottom: "24px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    },
    specialRequestsInput: {
        width: "100%",
        padding: "12px",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        fontSize: "14px",
        fontFamily: "inherit",
        resize: "vertical",
        backgroundColor: "#fafafa",
        "&:focus": {
            outline: "none",
            borderColor: "#ee6521",
        },
    },
    selectedSummary: {
        backgroundColor: "#f7faff",
        borderRadius: "12px",
        padding: "20px",
        border: "1px solid #e5edff",
    },
    selectedHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "16px",
    },
    cartIcon: {
        position: "relative",
    },
    cartBadge: {
        position: "absolute",
        top: "-8px",
        right: "-8px",
        backgroundColor: "#ee6521",
        color: "#fff",
        borderRadius: "50%",
        padding: "2px 6px",
        fontSize: "10px",
        fontWeight: "bold",
        minWidth: "16px",
        textAlign: "center",
    },
    selectedItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px",
        marginBottom: "8px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        border: "1px solid #e6ecff",
    },
    selectedItemInfo: {
        flex: 1,
    },
    selectedItemName: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#333",
        marginBottom: "4px",
    },
    selectedItemDetails: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontSize: "12px",
        color: "#666",
    },
    selectedItemActions: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
    },
    qtyMiniBtn: {
        width: "24px",
        height: "24px",
        borderRadius: "4px",
        border: "none",
        backgroundColor: "#ee6521",
        color: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        "&:hover": {
            backgroundColor: "#9a4cb0",
        },
    },
    qtyMiniValue: {
        minWidth: "20px",
        textAlign: "center",
        fontSize: "12px",
        fontWeight: "600",
    },
    removeBtn: {
        width: "24px",
        height: "24px",
        borderRadius: "4px",
        border: "none",
        backgroundColor: "#dc3545",
        color: "#fff",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: "4px",
        "&:hover": {
            backgroundColor: "#c82333",
        },
    },
    totalsBox: {
        borderTop: "1px solid #e5edff",
        paddingTop: "16px",
        marginTop: "16px",
        marginBottom: "16px",
    },
    totalLine: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "8px",
        fontSize: "14px",
        color: "#333",
    },
    submitBtn: {
        width: "100%",
        padding: "14px",
        backgroundColor: "#28a745",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#218838",
        },
    },
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
    },
    modalContent: {
        backgroundColor: "#fff",
        borderRadius: "16px",
        padding: "24px",
        width: "90%",
        maxWidth: "500px",
        maxHeight: "80vh",
        overflowY: "auto",
    },
    modalTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#ee6521",
        marginBottom: "20px",
    },
    addressList: {
        marginBottom: "20px",
    },
    addressItem: {
        display: "flex",
        gap: "12px",
        padding: "16px",
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        marginBottom: "12px",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            borderColor: "#ee6521",
            backgroundColor: "#f5f0ff",
        },
    },
    selectedAddressItem: {
        borderColor: "#ee6521",
        backgroundColor: "#f5f0ff",
    },
    addressDetails: {
        flex: 1,
    },
    addressCategory: {
        fontSize: "14px",
        fontWeight: "600",
        color: "#333",
        marginBottom: "4px",
    },
    addressText: {
        fontSize: "13px",
        color: "#666",
    },
    noAddress: {
        textAlign: "center",
        padding: "30px",
        color: "#999",
    },
    addAddressBtn: {
        width: "100%",
        padding: "14px",
        backgroundColor: "#ee6521",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontSize: "14px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#9a4cb0",
        },
    },
    /* Add these new styles to your styles object */
    twoColumnLayout: {
        display: "flex",
        gap: "20px",
        height: "65vh", // Adjust based on your header/back button
    },
    leftColumn: {
        flex: "7",
        overflowY: "auto",
        paddingRight: "10px",
        scrollbarWidth: "thin",
        height: "100%",
    },
    rightColumn: {
        flex: "5",
        position: "relative",
        height: "100%",
    },
    cartSticky: {
        position: "sticky",
        top: 0,
        backgroundColor: "#f7faff",
        borderRadius: "12px",
        padding: "20px",
        border: "1px solid #e5edff",
        maxHeight: "65vh",
        display: "flex",
        flexDirection: "column",
    },
    selectedList: {
        flex: 1,
        overflowY: "auto",
        marginBottom: "15px",
        scrollbarWidth: "thin",
        paddingRight: "5px",
        maxHeight: "400px", // Adjust as needed
    },
    cartTitle: {
        fontSize: "18px",
        fontWeight: "600",
        color: "#ee6521",
        margin: 0,
    },
    emptyCart: {
        textAlign: "center",
        padding: "40px 20px",
    },
    emptyCartText: {
        color: "#999",
        fontSize: "16px",
        marginBottom: "8px",
    },
    emptyCartSubtext: {
        color: "#ccc",
        fontSize: "14px",
    },
    totalValue: {
        fontWeight: "700",
        color: "#ee6521",
    },

};

// Add keyframe animation for spinner
const styleSheet = document.createElement("style");
styleSheet.textContent = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    input[type="checkbox"] {
        accent-color: #ee6521;
    }

    /* Switch styling */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .switch input:checked + .slider {
        background-color: #ee6521;
    }

    .switch input:checked + .slider:before {
        transform: translateX(22px);
    }
`;
document.head.appendChild(styleSheet);

export default CustomizeMenu;